import React from 'react';
import {format as formatSQL} from 'sql-formatter';
import {ErrorMessageComponentProps} from '@src/exceptions/AbstractPrintableHttpException';
import ServerSQLErrorHttpException from '@src/exceptions/ServerSQLErrorHttpException';
import {writeToClipboard} from '@src/helpers/clipboard';

export default function SQLErrorMessage(props: ErrorMessageComponentProps) {
    const error = props.error;
    if (!(error instanceof ServerSQLErrorHttpException) || !error.getErrorDetails()) {
        return <div>{error.message}</div>;
    }

    const details = error.getErrorDetails() as NonNullable<ReturnType<typeof error.getErrorDetails>>;

    let sql = details.sql;
    try {
        sql = formatSQL(sql);
    } catch (e) {
    }

    return <div>
        <h5>
            <span className="small">[{details.code} | {details.driver.code}]: </span>
            {details.driver.message}
        </h5>
        <div className="mt-2 position-relative">
            <pre className="mb-1" style={{
                fontSize: '120%',
                border: 'solid 1px',
                padding: '3px 6px',
                borderRadius: '3px',
            }}>{sql}</pre>
            <button
                    type="button"
                    className="btn btn-sm btn-info"
                    style={{
                        position: 'absolute',
                        top: '5px',
                        right: '5px',
                    }}
                    onClick={() => {
                        writeToClipboard(details.sql).then();
                    }}
            >
                <i className="fa fa-copy"/>
            </button>
        </div>
    </div>;
}
